import React, { Component } from 'react';
import { X } from 'lucide-react';
import './Modal.css';

class Modal extends Component {
    render() {
        const { children, title, onClose, large = false } = this.props;

        return (
            <div className="modal-overlay">
                <div className={`modal-content ${large ? 'modal-large' : ''}`}>
                    <div className="modal-header">
                        <h2>{title}</h2>
                        <button onClick={onClose} className="close-btn">
                            <X />
                        </button>
                    </div>
                    {children}
                </div>
            </div>
        );
    }
}

export default Modal;
